import {FormikHelpers, useFormik} from 'formik'
import * as Yup from 'yup'
import {useStatusMessage} from '../../../features'
import {Post, RootState} from '../../../../setup'
import {useParams} from 'react-router-dom'
import {UserInterface} from '../../../modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {ChangeEvent, useRef, useState} from 'react'
import {useSAV} from '../../../@types'

const SEND_MESSAGE = process.env.REACT_APP_SAV_TICKETS_FORM_SEND_MESSAGE || 'sav/save-ticket'

const Schema = Yup.object().shape({
  message: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(500, 'Maximum 500 symbols')
    .required('Obligatoire'),
  files: Yup.mixed(),
})

const initialValues = {
  message: '',
  files: [] as File[],
}
const Footer = () => {

  const {id: ticketId}: {id: string} = useParams()
  const {triggerReload} = useSAV()
  const {id: userId}: UserInterface = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface
  const {formState, setLoading} = useStatusMessage()
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [filesCount, setFilesCount] = useState<number>(0)

  const onSubmit = async (values: typeof initialValues, {
    setSubmitting,
    resetForm,
  }: FormikHelpers<typeof initialValues>) => {

    setLoading(true)
    setSubmitting(false)

    const formData = new FormData()
    formData.append('client_id', `${userId}`)
    formData.append('sav_ticket_id', ticketId)
    formData.append('message', values.message)
    values.files.forEach(file => formData.append('files[]', file))

    try {

      const {status} = await Post<{status: number}>(SEND_MESSAGE, formData)
      if (status === 200) {
        if (status === 200) {
          triggerReload()
          formik.resetForm()
        }
      }

    } catch (err) {
      console.error('Error submitting the form:', err)
    } finally {
      setLoading(false)
      setSubmitting(false)
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit,
  })

  const HandleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []) as File[]
    if (files) {
      // Handle file upload logic here
      formik.setFieldValue('files', files)
      setFilesCount(files.length)
    }
  }

  const HandleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <textarea className="form-control form-control-solid mb-3"
                rows={4}
                data-kt-element="input"
                placeholder="Type a message"
                {...formik.getFieldProps('message')}
      />
      {formik.touched.message && formik.errors.message && (
        <div className="fv-plugins-message-container my-1 w-100">
          <div className="fv-help-block">
            <span role="alert" className="text-danger p-2">{formik.errors.message}</span>
          </div>
        </div>
      )}

      <div className="d-flex flex-stack">
        <div className="d-flex align-items-center me-2">
          <input type="file"
                 ref={fileInputRef}
                 onChange={HandleFileChange}
                 accept=".png, .jpg, .jpeg, .pdf, .docx, .csv"
                 multiple
                 style={{display: 'none'}}
          />
          <button className="btn btn-sm btn-icon btn-active-light-primary me-1"
                  type="button"
                  onClick={HandleFileClick}

          >
            <i className="bi bi-paperclip fs-3"></i>
          </button>
          <div className="">
            <span className="fw-bold fs-6 text-gray-900 px-5">
                {filesCount > 0 ? `${filesCount} fichiers` : ''}
            </span>
          </div>
        </div>

        <button type="submit"
                className="btn btn-primary"
                disabled={formik.isSubmitting || !formik.isValid}
        >
          {!formState.loading && <span className="indicator-label">Envoyer</span>}
          {formState.loading && (
            <span className="indicator-progress" style={{display: 'block'}}>
                S'il vous plaît, attendez...
                <span className="spinner-border spinner-border-sm align-middle ms-2" />
            </span>
          )}
        </button>
      </div>
    </form>
  )
}

export {Footer}